import get from 'lodash/get';
import { updateSupportData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { ENDPOINT_URL_MAP } from '../../../AdvWorkflow/AdvWorkflowConstants';
import { BACKEND_KEY } from '../../LargePurchaseWorkflowConstants';

export default (isNew, workflowId, clientId, data) => async (dispatch) => {
  if (!isNew) {
    return;
  }
  const {
    ADV: {
      util: { request },
    },
  } = window;
  const response = await request(
    {
      uri: ENDPOINT_URL_MAP[workflowId],
      type: 'GET',
      data: {
        clientId,
        'paths[0]': 'LargePurchaseGoals',
      },
      showSpinner: true,
    },
    true,
  );

  if (response.success) {
    dispatch(updateSupportData(
      {
        LargePurchaseGoal: get(response, 'payload.viewData.LargePurchaseGoals', []).reduce(
          (acc, current) => {
            if (current.Name === data[BACKEND_KEY].Name) {
              return {
                Id: current.Id,
              };
            }
            return acc;
          },
          {
            Name: null,
            DesiredPurchaseYear: null,
            Cost: null,
          },
        ),
      },
      workflowId,
    ));
  }
};

export const onPostProcess = (_, goalArg) => {
  const goal = goalArg;
  if (goal.PurchaseAtRetirement) {
    goal.DesiredPurchaseYear = null;
  }
  return { [BACKEND_KEY]: goal };
};
